<template>
  <div class="tab-content clearfix" id="dropArea" v-scroll>
    <div class="tab-pane fade active in" :id="tab">
      <div class="drive">
        <div :class="[isList ? 'lists' : 'grids']" style="display: block">
          <keep-alive>
            <component
              :isList="isList"
              :is="header"
              @handleSaveSelected="handleSaveSelected"
            ></component>
          </keep-alive>
          <div class="list-content">
            <div
              v-for="(data, index) in datas"
              :key="index"
              class="itemlist"
              :class="{
                act: data.isSelected ? true : false,
                itemlist2: !isList && isThumb(data.file_ext),
              }"
              @contextmenu.prevent="rightEvent(data, $event)"
              @click="selectRow(data)"
            >
              <div class="item-check">
                <div class="checkbox">
                  <i class="ti-check"></i>
                </div>
              </div>
              <div
                class="item-name"
                :style="imgPathFilter(data)"
                @click.stop="handleClickIcon(data)"
              >
                <div class="file-icon">
                  <svg
                    aria-hidden="true"
                    class="icon"
                    v-if="
                      ((showOnFile &&
                        !(data.number == 0 && data.disk_type === 'backup')) ||
                        showOnStar ||
                        showOnTrash ||
                        showOnGroupFile) &&
                      ((!isThumb(data.file_ext) && !isList) || isList)
                    "
                  >
                    <use
                      :xlink:href="
                        '#icon-' +
                        getIcon(data.type, data.file_type, data.file_ext)
                      "
                    />
                  </svg>
                  <svg
                    aria-hidden="true"
                    class="icon"
                    v-if="
                      showOnSharefile ||
                      showOnShareme ||
                      showOnGroupShare ||
                      showOnGroupSend
                    "
                  >
                    <use xlink:href="#icon-folder-zy" />
                  </svg>
                  <svg
                    aria-hidden="true"
                    class="icon"
                    v-if="
                      showOnFile &&
                      data.number == 0 &&
                      data.disk_type === 'backup'
                    "
                  >
                    <use xlink:href="#icon-folde-copy" />
                  </svg>
                </div>
                <input
                  v-focus="focusState"
                  v-show="data.isEdit"
                  type="text"
                  class="fileName"
                  :value="data.name"
                  @keyup.esc="cancleSaveNewFolder(data)"
                  @keyup.enter="saveNewFolderByEnter(data, $event)"
                  @click.stop="`return false`"
                />
                <button
                  class="btn btn-info"
                  title="保存"
                  type="button"
                  v-if="data.isEdit"
                  @click.stop="saveNewFolderByBtn(data, $event)"
                  :disabled="isProcessing || isCreateProcessing"
                >
                  <i
                    :class="[
                      'fa',
                      isProcessing || isCreateProcessing
                        ? 'fa-spinner'
                        : 'fa-check',
                    ]"
                  ></i>
                </button>
                <button
                  class="btn btn-info"
                  title="取消"
                  type="button"
                  v-if="data.isEdit"
                  @click.stop="cancleSaveNewFolder(data)"
                  :disabled="isProcessing || isCreateProcessing"
                >
                  <i class="fa fa-times"></i>
                </button>
                <span
                  class="help-rename"
                  v-show="data.isEdit && errors.has('title')"
                  >{{ errors.first("title") }}</span
                >
                <p v-show="!data.isEdit">
                  <i
                    class="iconfont icon-share-link"
                    title="链接"
                    v-if="showOnSharefile && data.share_type === 'link'"
                  ></i>
                  <i
                    class="iconfont icon-share-user"
                    title="用户"
                    v-if="showOnSharefile && data.share_type === 'user'"
                  ></i>
                  <i
                    class="iconfont icon-share-group"
                    title="群组"
                    v-if="showOnSharefile && data.share_type === 'group'"
                  ></i>
                  <a
                    @click.stop="preview(data)"
                    :title="data | formatData"
                    v-if="
                      data.type === 'file' &&
                      (showOnFile || showOnStar || showOnGroupFile)
                    "
                    >{{ data | formatData }}</a
                  >
                  <a
                    :title="data | formatData"
                    @click.stop="getInfoByFatherId(data)"
                    v-if="
                      data.type === 'folder' &&
                      (showOnFile || showOnStar || showOnGroupFile)
                    "
                    >{{ data | formatData }}</a
                  >
                  <a v-if="showOnTrash" @click.stop="handleTrash">{{
                    data | formatData
                  }}</a>
                  <a
                    :title="data.share_title"
                    @click.stop="getShareResourceList(data)"
                    v-if="showOnGroupShare || showOnShareme || showOnSharefile"
                    >{{ data.share_title }}</a
                  >
                  <a
                    :title="data.link_title"
                    @click.stop="getLinkResourceList(data)"
                    v-if="showOnGroupSend"
                    >{{ data.link_title }}</a
                  >
                </p>
                <!-- <span
                  v-if="
                    data.file_type === 'video' &&
                    data.transcode_status !== 'none' &&
                    !data.isEdit &&
                    (showOnFile || showOnStar)
                  "
                  :class="data | transcodeStatusFilter"
                  class="isTransed"
                  :title="data.transcode_title"
                  @click.stop="fileTranstate(data, $event)"
                ></span> -->
                <span
                  v-if="data.is_lock === true"
                  class="glyphicon glyphicon-lock isLocked"
                  :title="data.lock_reason ? data.lock_reason : '锁定'"
                ></span>
                <span
                  v-if="
                    data.share_count &&
                    (showOnFile || showOnStar || showOnGroupFile) &&
                    !data.isEdit
                  "
                  class="glyphicon glyphicon-share isShared"
                  :title="showOnGroupFile ? '已发布' : '已分享'"
                ></span>
              </div>
              <div
                class="item-size"
                v-if="data.type === 'folder' && isList && showOnGroupFile"
              >
                {{ getRole(data) }}
              </div>
              <div
                class="item-size"
                v-if="data.type === 'file' && isList && showOnGroupFile"
              >
                -
              </div>
              <div
                class="item-size"
                v-if="
                  isList &&
                  (showOnFile || showOnStar || showOnTrash || showOnGroupFile)
                "
              >
                {{ data | bytesToSize }}
              </div>
              <div
                class="item-share item-cut"
                v-if="isList && showOnSharefile"
                :title="data | shareToFilter"
              >
                {{ data | shareToFilter }}
              </div>
              <div
                class="item-share"
                v-if="isList && (showOnShareme || showOnGroupShare)"
              >
                {{ data.share_creater_name }}
              </div>
              <div class="item-share" v-if="isList && showOnGroupSend">
                {{ data.link_creater_name }}
              </div>

              <div
                class="item-time"
                v-if="
                  isList &&
                  (showOnFile || showOnStar || showOnTrash || showOnGroupFile)
                "
              >
                <span class="item-date-sm">{{
                  data.last_update_date ? data.last_update_date : "-"
                }}</span>
              </div>
              <div
                class="item-time"
                v-if="
                  isList &&
                  (showOnSharefile || showOnShareme || showOnGroupShare)
                "
              >
                <span class="item-date-sm">{{
                  data.share_created_date ? data.share_created_date : "-"
                }}</span>
              </div>
              <div class="item-time" v-if="isList && showOnGroupSend">
                <span class="item-date-sm">{{
                  data.link_created_date ? data.link_created_date : "-"
                }}</span>
              </div>

              <div
                class="item-author"
                v-if="
                  isList &&
                  (showOnFile || showOnStar || showOnTrash || showOnGroupFile)
                "
              >
                {{
                  data.creater_user_real_name
                    ? data.creater_user_real_name
                    : "-"
                }}
              </div>

              <div
                class="item-views"
                v-if="
                  isList &&
                  (showOnSharefile ||
                    showOnShareme ||
                    showOnGroupShare ||
                    showOnGroupSend)
                "
              >
                {{ data.share_view_count }}
              </div>
              <div class="item-views" v-if="isList && showOnGroupSend">
                {{ data.link_view_count }}
              </div>

              <div class="item-menu">
                <a
                  class="hidden-xs"
                  @click.stop="handleData(data, 'tag')"
                  v-if="
                    right__resource_tag && ((showOnFile && data.number != '0') ||
                    showOnStar ||
                    hasOnePermission(data, 'setStarCloudResource'))
                  "
                >
                  <i class="iconfont icon-tag" title="标签"></i>
                </a>
                <a
                  class="hidden-xs"
                  @click.stop="handleData(data, 'share')"
                  v-if="right__share_create && ((showOnFile && data.number != '0') || showOnStar)"
                >
                  <i class="iconfont icon-share" title="分享"></i>
                </a>
                <a
                  class="hidden-xs star"
                  v-if="right__startag && ((showOnFile && data.number != '0') || showOnStar)"
                  @click.stop="toggleStar(data)"
                >
                  <i
                    class="iconfont"
                    :class="[data.is_star ? 'icon-star-full' : 'icon-star']"
                    title="星标"
                  ></i>
                </a>
                <div class="dropdown" v-if="showMoreBtn(data) && (data.number != '0')" ref="dropdown">
                  <a
                    aria-expanded="true"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    id="dropdownMenu2"
                    data-toggle="dropdown"
                    @click.stop="toggleDropdown($event)"
                  >
                    <i class="iconfont icon-more" title="更多"></i>
                  </a>
                  <ul
                    aria-labelledby="dropdownMenu2"
                    class="dropdown-menu dropdown-menu-right"
                  >
                    <li
                      v-if="
                        data.type === 'file' &&
                        hasOnePermission(data, 'previewResource')
                      "
                      @click.stop="preview(data, true)"
                    >
                      <a>
                        <i class="fa fa-file-o"></i>
                        预览
                      </a>
                    </li>
                    <li
                      v-if="
                        data.type === 'folder' &&
                        hasOnePermission(data, 'resourceInfo')
                      "
                      @click.stop="getInfoByFatherId(data)"
                    >
                      <a>
                        <i class="fa fa-folder-o"></i>
                        打开
                      </a>
                    </li>
                    <li
                      v-if="
                        data.type === 'file' &&
                        (showOnFile ||
                          showOnStar ||
                          hasOnePermission(data, 'downloadResource'))
                      "
                      @click.stop="download(data)"
                    >
                      <a>
                        <i class="ti-download"></i>
                        下载
                      </a>
                    </li>
                    <!-- <li
                      v-if="
                        right__edit_number && data.type === 'file' &&
                        (showOnFile ||
                          showOnStar ||
                          hasOnePermission(data, 'editFile')) &&
                        [
                          'docx',
                          'xlsx',
                          'pptx',
                          'md',
                          'markdown',
                          'pdf',
                        ].includes(data.file_ext)
                      "
                      @click="edit(data)"
                    >
                      <a> <i class="iconfont icon-send"></i>编辑 </a>
                    </li> -->
                    <li
                      v-if="
                        right__rename && (showOnFile ||
                        showOnStar ||
                        (hasOnePermission(data, 'renameFile') &&
                          data.type === 'file') ||
                        (hasOnePermission(data, 'renameFolder') &&
                          data.type === 'folder'))
                      "
                      @click.stop="handleRename(data)"
                    >
                      <a>
                        <i class="iconfont icon-send"></i>
                        重命名
                      </a>
                    </li>
                    <!-- <li
                      v-if="right__operationFileOrFolder && (showOnFile || showOnStar)"
                      @click.stop="handleCopyData(data, 'copy')"
                    >
                      <a>
                        <i class="iconfont icon-copy"></i>
                        复制到
                      </a>
                    </li> -->
                    <li
                      v-if="right__operationFileOrFolder && (showOnFile || showOnStar)"
                      @click.stop="handleMoveData(data, 'move')"
                    >
                      <a>
                        <i class="iconfont icon-move"></i>
                        移动到
                      </a>
                    </li>
                    <!-- <li
                      v-if="right__group_resource_savetocloud && hasOnePermission(data, 'saveResourceToCloud')"
                      @click.stop="handleSave(data, 'save')"
                    >
                      <a>
                        <i class="ti-harddrives"></i>
                        保存到
                      </a>
                    </li> -->
                    <li
                      v-if="right__operationFileOrFolder && showOnTrash"
                      @click.stop="handleMoveData(data, 'restore')"
                    >
                      <a>
                        <i class="ti-back-left"></i>
                        还原
                      </a>
                    </li>
                    <li
                      v-if="right__operationFileOrFolder && showOnTrash"
                      @click.stop="deleteFileOrFolder(data)"
                    >
                      <a>
                        <i class="iconfont icon-trash"></i>
                        彻底删除
                      </a>
                    </li>
                    <li
                      v-if="right__operationFileOrFolder && (showOnFile || showOnStar)"
                      @click.stop="recycleFileOrFolder(data)"
                    >
                      <a>
                        <i class="iconfont icon-trash"></i>
                        删除
                      </a>
                    </li>
                    <li
                      v-if="right__operationFileOrFolder && hasOnePermission(data, 'deleteResource')"
                      @click.stop="deleteFileOrFolder(data)"
                    >
                      <a>
                        <i class="iconfont icon-trash"></i>
                        删除
                      </a>
                    </li>
                    <li
                      v-if="showOnSharefile"
                      @click.stop="handleShareData(data, 'shareinfo')"
                    >
                      <a>
                        <i class="iconfont icon-file"></i>
                        分享详情
                      </a>
                    </li>
                    <li
                      v-if="right__share_edit && showOnSharefile"
                      @click.stop="handleShareData(data, 'share_edit')"
                    >
                      <a>
                        <i class="ti-pencil-alt"></i>
                        编辑分享
                      </a>
                    </li>
                    <li
                      v-if="right__share_delete && showOnSharefile"
                      @click.stop="deleteShareOnShareFile(data)"
                    >
                      <a>
                        <i class="iconfont icon-trash"></i>
                        取消分享
                      </a>
                    </li>
                    <li
                      v-if="showOnShareme || showOnGroupShare"
                      @click.stop="handleShareTargetData(data, 'shareinfo')"
                    >
                      <a>
                        <i class="iconfont icon-file"></i>
                        分享详情
                      </a>
                    </li>
                    <li
                      v-if="showOnGroupSend"
                      @click.stop="handleLinkData(data, 'shareinfo')"
                    >
                      <a>
                        <i class="iconfont icon-file"></i>
                        发布详情
                      </a>
                    </li>
                    <li
                      v-if="
                        right__link && (showOnGroupSend &&
                        (permissions.public_operations == 'ALL' ||
                          data.link_creater_number === user.user_number))
                      "
                    >
                      <a @click.stop="handleSend('send_edit', data)">
                        <i class="ti-pencil-alt"></i>
                        编辑发布
                      </a>
                    </li>
                    <li
                      v-if="
                        right__share_remove && ((showOnGroupShare &&
                          (hasDeleteSharePermission ||
                            data.share_creater_number === user.user_number)) ||
                        showOnShareme)
                      "
                      @click.stop="removeShares(data)"
                    >
                      <a>
                        <i class="iconfont icon-trash"></i>
                        移除分享
                      </a>
                    </li>
                    <li
                      v-if="
                       right__link_delete && (showOnGroupSend &&
                        (permissions.public_operations == 'ALL' ||
                          data.link_creater_number === user.user_number))
                      "
                      @click.stop="deleteLinks(data)"
                    >
                      <a>
                        <i class="iconfont icon-trash"></i>
                        取消发布
                      </a>
                    </li>
                    <li
                      v-if="
                        right__group_resource_role_batch_grant_to_members && (showOnGroupFile &&
                        data.type === 'folder' &&
                        data.parent_number === '0' &&
                        hasOnePermission(data, 'editResourcePermission'))
                      "
                      @click.stop="setResourcePermission(data)"
                    >
                      <a><i class="ti-settings"></i>设置共享</a>
                    </li>
                    <li
                      v-if="
                        right__file_version_back_preview && ((showOnFile ||
                          (showOnGroupFile &&
                            hasOnePermission(data, 'viewHistoryVersion'))) &&
                        data.type === 'file')
                      "
                      @click="handleData(data, 'file-history')"
                    >
                      <a><i class="iconfont icon-link-check"></i>历史版本</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="scroll-loading" v-show="loading && isScrollTab">
              正在加载中...
            </div>
            <div class="loadingbox" v-show="loading && !isScrollTab">
              <section class="loading Animation1">
                <section class="shape shape-1"></section>
                <section class="shape shape-2"></section>
                <section class="shape shape-3"></section>
                <section class="shape shape-4"></section>
              </section>
              <h4>正在加载，请稍后……</h4>
            </div>
            <div
              class="nofile nofile-padding"
              v-if="nothing && (showOnFile || showOnGroupFile)"
            >
              <div class="pic">
                <img src="@/assets/images/nofile.svg" />
              </div>
              <h4>
                还没上传任何文件{{
                  !showOnGroupFile ||
                  (showOnGroupFile && hasUploadFilePermission)
                    ? "(可将文件或文件夹拖到此处进行上传)"
                    : ""
                }}
              </h4>
              <p>
                {{
                  showOnFile
                    ? "将个人文件存放到云盘中以便随时访问它们。"
                    : "将文件存放到群盘中，与群成员一起共享访问它们。"
                }}
              </p>
              <div class="nobtn" v-if="(this.$store.getters.right__folder_tree || this.$store.getters.right__file_number) && (tab !== 'persona-file')">
                <div
                  class="dropdown"
                  v-if="!showOnGroupFile || showOnGroupFile"
                >
                  <button
                    aria-expanded="true"
                    aria-haspopup="true"
                    class="btn btn-primary"
                    data-toggle="dropdown"
                    id="dropdownMenu2"
                    type="button"
                  >
                    <i class="iconfont icon-upload"></i>
                    上传
                    <span class="caret"></span>
                  </button>
                  <ul
                    aria-labelledby="dropdownMenu2"
                    class="dropdown-menu dropdown-menu-right"
                  >
                    <li v-if="this.$store.getters.right__folder_tree">
                      <a @click="handleUploadFolder">
                        <i class="iconfont icon-folder-upload"></i>
                        上传文件夹
                      </a>
                    </li>
                    <li v-if="this.$store.getters.right__file_number">
                      <a @click="handleUploadFiles">
                        <i class="iconfont icon-file"></i>
                        上传文件
                      </a>
                    </li>
                  </ul>
                </div>
                <button
                  v-if="this.$store.getters.right__folder_tree && (!showOnGroupFile || showOnGroupFile)"
                  class="btn btn-default"
                  type="button"
                  @click="createNewFolder"
                >
                  <i class="iconfont icon-folder-plus"></i>
                  新建文件夹
                </button>
              </div>
            </div>
            <div class="nofile" v-if="nothing && showOnStar">
              <div class="pic">
                <img src="@/assets/images/nocollect.svg" />
              </div>
              <h4>还没任何标星文件</h4>
              <p>
                将个人云盘文件中经常需要用到的文档标星，可以在这里快速找到它们。
              </p>
            </div>
            <div class="nofile" v-if="nothing && showOnSharefile">
              <div class="pic">
                <img src="@/assets/images/noshare.svg" />
              </div>
              <h4>您还没有分享过文件</h4>
            </div>
            <div class="nofile" v-if="nothing && showOnShareme">
              <div class="pic">
                <img src="@/assets/images/noshareme.svg" />
              </div>
              <h4>还没人通过“用户分享”文件给你</h4>
            </div>
            <div class="nofile" v-if="nothing && showOnTrash">
              <div class="pic">
                <img src="@/assets/images/norecover.svg" />
              </div>
              <h4>回收站为空，没有要回收的项。</h4>
              <p></p>
            </div>
            <div class="nofile" v-if="nothing && showOnGroupShare">
              <div class="pic">
                <img src="@/assets/images/nogroupshare.svg" />
              </div>
              <h4>还没人通过“群组分享”文件到这里</h4>
              <p>
                群成员可以将个人云盘文件快速分享到这里，与群成员一起共享访问它们。
              </p>
              <div class="nobtn">
                <router-link
                  :to="{ name: 'recdrive' }"
                  target="_blank"
                  class="btn btn-default"
                  type="button"
                  >进入个人云盘开始分享</router-link
                >
              </div>
            </div>
            <div class="nofile" v-if="nothing && showOnGroupSend">
              <div class="pic">
                <img src="@/assets/images/nogroupsend.svg" />
              </div>
              <h4>还没有发布资源</h4>
              <p>可以将群盘中文件发布出去，让其他主页能够使用它们。</p>
              <div class="nobtn" v-if="right__link">
                <button
                  class="btn btn-default"
                  type="button"
                  @click="handleSend('send')"
                >
                  <i class="iconfont icon-newgroup"></i>
                  新建
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Save
      :resources="resources"
      :folder="folder"
      v-if="status.SaveStatus"
    ></Save>
    <TableShare :detail="detail" v-if="status.TableShareStatus"></TableShare>
    <TableShareSelected
      v-if="status.TableShareSelectedStatus"
    ></TableShareSelected>
    <TableTag :detail="detail" v-if="status.TableTagStatus"></TableTag>
    <TableMove
      :detail="detail"
      @reloadInfo="getInfo"
      v-if="status.TableMoveStatus"
    ></TableMove>
    <TableMoveSelected
      v-if="status.TableMoveSelectedStatus"
    ></TableMoveSelected>
    <TableRestore
      :detail="detail"
      @reloadInfo="getInfo"
      v-if="status.TableRestoreStatus"
    ></TableRestore>
    <TableRestoreSelected
      v-if="status.TableRestoreSelectedStatus"
    ></TableRestoreSelected>
    <TableCopy
      :detail="detail"
      @reloadInfo="getInfo"
      v-if="status.TableCopyStatus"
    ></TableCopy>
    <TableCopySelected
      v-if="status.TableCopySelectedStatus"
    ></TableCopySelected>

    <TableShareEdit
      :detail="detail"
      v-if="status.TableShareEditStatus"
    ></TableShareEdit>
    <TableShareInfo
      :detail="detail"
      v-if="status.TableShareInfoStatus"
    ></TableShareInfo>
    <FileHistory :detail="detail"></FileHistory>
    <videoPreview
      :detail="detail"
      :preview_path="preview_path"
      @handlePreviewData="handlePreviewData"
      @deletePreviewData="deletePreviewData"
      @changePreviewStatus="changePreviewStatus"
      v-if="status.videoPreviewStatus"
    ></videoPreview>
    <audioPreview
      :detail="detail"
      :preview_path="preview_path"
      v-if="status.audioPreviewStatus"
    ></audioPreview>
    <txtPreview
      :detail="detail"
      :preview_path="preview_path"
      @handlePreviewData="handlePreviewData"
      @deletePreviewData="deletePreviewData"
      @changePreviewStatus="changePreviewStatus"
      v-if="status.txtPreviewStatus"
    ></txtPreview>
    <officePreview
      :detail="detail"
      :dialogStatus="dialogStatus"
      :preview_path="preview_path"
      @handlePreviewData="handlePreviewData"
      @deletePreviewData="deletePreviewData"
      @changePreviewStatus="changePreviewStatus"
      v-if="status.officePreviewStatus"
    ></officePreview>
    <pdfPreview
      :detail="detail"
      :dialogStatus="dialogStatus"
      :preview_path="preview_path"
      @handlePreviewData="handlePreviewData"
      @deletePreviewData="deletePreviewData"
      @changePreviewStatus="changePreviewStatus"
      @changeVersion="changeVersion"
      @updateCreateToEditStatus="updateCreateToEditStatus"
      @updateEditToCreateStatus="updateEditToCreateStatus"
      @getInfo="getInfo"
      v-if="status.pdfPreviewStatus"
    ></pdfPreview>
    <markdownPreview
      :detail="detail"
      :dialogStatus="dialogStatus"
      :preview_path="preview_path"
      @handlePreviewData="handlePreviewData"
      @deletePreviewData="deletePreviewData"
      @changePreviewStatus="changePreviewStatus"
      @changeVersion="changeVersion"
      @updateCreateToEditStatus="updateCreateToEditStatus"
      @updateEditToCreateStatus="updateEditToCreateStatus"
      @getInfo="getInfo"
      v-if="status.markdownPreviewStatus"
    ></markdownPreview>
    <imgPreview
      :imgs="imgs"
      @handlePreviewData="handlePreviewData"
      @deletePreviewData="deleteImagePreviewData"
      @changePreviewStatus="changePreviewStatus"
      v-if="status.imgPreviewStatus"
    ></imgPreview>
    <GroupResourcePermission
      :group_number="groupNumber"
      :folder="detail"
    ></GroupResourcePermission>
    <div
      class="right-menu"
      :style="rightMenustyle"
      v-if="showRightMenu"
      v-clickoutside="closeRightMenu"
    >
      <a
        class="hidden-xs"
        @click="handleData(detail, 'tag')"
        v-if="
          right__resource_tag && (showOnFile ||
          showOnStar ||
          hasOnePermission(detail, 'setStarCloudResource'))
        "
      >
        <i class="iconfont icon-tag"></i>
        标签
      </a>
      <a
        class="hidden-xs"
        @click="handleData(detail, 'share')"
        v-if="right__share_create && (showOnFile || showOnStar)"
      >
        <i class="iconfont icon-share"></i>
        分享
      </a>
      <a
        class="hidden-xs star"
        v-if="right__startag && (showOnFile || showOnStar)"
        @click="toggleStar(detail)"
      >
        <i
          class="iconfont"
          :class="[detail.is_star ? 'icon-star-full' : 'icon-star']"
        ></i>
        {{ detail.is_star ? "取消星标" : "星标" }}
      </a>
      <a
        v-if="
          detail.type === 'file' &&
          (showOnFile ||
            showOnStar ||
            hasOnePermission(detail, 'previewResource'))
        "
        @click="preview(detail, true)"
      >
        <i class="fa fa-file-o"></i>
        预览
      </a>
      <!-- <a
        v-if="
          right__edit_number && detail.type === 'file' &&
          (showOnFile || showOnStar || hasOnePermission(detail, 'editFile')) &&
          ['docx', 'xlsx', 'pptx', 'md', 'markdown', 'pdf'].includes(
            detail.file_ext
          )
        "
        @click="edit(detail)"
      >
        <i class="iconfont icon-send"></i>
        编辑
      </a> -->
      <a
        v-if="
          detail.type === 'file' &&
          (showOnFile ||
            showOnStar ||
            hasOnePermission(detail, 'downloadResource'))
        "
        @click="download(detail)"
      >
        <i class="ti-download"></i>
        下载
      </a>
      <a
        v-if="
          right__rename && (showOnFile || showOnStar || hasOnePermission(detail, 'renameFile'))
        "
        @click="handleRename(detail)"
      >
        <i class="iconfont icon-send"></i>
        重命名
      </a>
      <!-- <a
        v-if="right__operationFileOrFolder && (showOnFile || showOnStar)"
        @click="handleCopyData(detail, 'copy')"
      >
        <i class="iconfont icon-copy"></i>
        复制到
      </a> -->
      <a
        v-if="right__operationFileOrFolder && (showOnFile || showOnStar)"
        @click="handleMoveData(detail, 'move')"
      >
        <i class="iconfont icon-move"></i>
        移动到
      </a>
      <!-- <a
        v-if="right__group_resource_savetocloud && hasOnePermission(detail, 'saveResourceToCloud')"
        @click="handleSave(detail, 'save')"
      >
        <i class="ti-harddrives"></i>
        保存到
      </a> -->
      <a v-if="right__operationFileOrFolder && showOnTrash" @click="handleMoveData(detail, 'restore')">
        <i class="ti-back-left"></i>
        还原
      </a>
      <a v-if="right__operationFileOrFolder && showOnTrash" @click="deleteFileOrFolder(detail)">
        <i class="iconfont icon-trash"></i>
        彻底删除
      </a>
      <a v-if="right__operationFileOrFolder && (showOnFile || showOnStar)" @click="recycleFileOrFolder(detail)">
        <i class="iconfont icon-trash"></i>
        删除
      </a>
      <a
        v-if="right__operationFileOrFolder && hasOnePermission(detail, 'deleteResource')"
        @click="deleteFileOrFolder(detail)"
      >
        <i class="iconfont icon-trash"></i>
        删除
      </a>
      <a v-if="showOnSharefile" @click="handleShareData(detail, 'shareinfo')">
        <i class="iconfont icon-file"></i>
        分享详情
      </a>
      <a v-if="right__share_edit && showOnSharefile" @click="handleShareData(detail, 'share_edit')">
        <i class="ti-pencil-alt"></i>
        编辑分享
      </a>
      <a @click="deleteShareOnShareFile(detail)" v-if="right__share_delete && showOnSharefile">
        <i class="iconfont icon-trash"></i>
        取消分享
      </a>
      <a
        v-if="showOnShareme || showOnGroupShare"
        @click="handleShareTargetData(detail, 'shareinfo')"
      >
        <i class="iconfont icon-file"></i>
        分享详情
      </a>
      <a v-if="showOnGroupSend" @click="handleLinkData(detail, 'shareinfo')">
        <i class="iconfont icon-file"></i>
        发布详情
      </a>
      <a
        v-if="
          right__share_remove && (showOnShareme ||
          (showOnGroupShare &&
            (hasDeleteSharePermission ||
              detail.share_creater_number === user.user_number)))
        "
        @click="removeShares(detail)"
      >
        <i class="iconfont icon-trash"></i>
        移除分享
      </a>
      <a
        v-if="
         right__link && (showOnGroupSend &&
          (permissions.public_operations == 'ALL' ||
            detail.link_creater_number === user.user_number))
        "
        @click="handleSend('send_edit', detail)"
      >
        <i class="ti-pencil-alt"></i>
        编辑发布
      </a>
      <a
        v-if="
          right__link_delete && (showOnGroupSend &&
          (permissions.public_operations == 'ALL' ||
            detail.link_creater_number === user.user_number))
        "
        @click="deleteLinks(detail)"
      >
        <i class="iconfont icon-trash"></i>
        取消发布
      </a>
      <!-- <a
        v-if="
          right__group_resource_role_batch_grant_to_members && (showOnGroupFile &&
          detail.type === 'folder' &&
          detail.parent_number === '0' &&
          hasOnePermission(detail, 'editResourcePermission'))
        "
        @click="setResourcePermission(detail)"
        ><i class="ti-settings"></i>设置共享</a
      > -->
      <!-- <a
        v-if="
          right__file_version_back_preview && ((showOnFile ||
            (showOnGroupFile &&
              hasOnePermission(detail, 'viewHistoryVersion'))) &&
          detail.type === 'file')
        "
        @click="handleData(detail, 'file-history')"
      >
        <i class="iconfont icon-link-check"></i>
        历史版本
      </a> -->
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus";
import { getIcon, getPreviewType } from "@/utils/icon";
import { getRolePermissions, getRole } from "@/utils/permission";
import { previewTxts } from "@/config/index";
import {
  bytesToSize,
  listToTree,
  listToTreeForCopy,
  transcodeStatusFilter,
  formatData,
  formatSeconds,
  isThumb,
} from "@/utils/index";
import { verifyFilename } from "@/utils/verify";
import {
  getFileInfo,
  download,
  fileTranstate,
  fileTranstateStatus,
  preview,
  edit,
} from "@/api/drive/drive";
import { shareInfo, shareTargetInfo, linkInfo } from "@/api/share/share";
export default {
  name: "Table",
  components: {
    TableHeaderFile: () => import("./TableHeader/TableHeaderFile"),
    TableHeaderShare: () => import("./TableHeader/TableHeaderShare"),
    TableMove: () => import("./TableOperate/TableMove"),
    TableMoveSelected: () => import("./TableOperate/TableMoveSelected"),
    TableRestore: () => import("./TableOperate/TableRestore"),
    TableRestoreSelected: () => import("./TableOperate/TableRestoreSelected"),
    TableCopy: () => import("./TableOperate/TableCopy"),
    TableCopySelected: () => import("./TableOperate/TableCopySelected"),
    videoPreview: () => import("@/components/Table/TablePreview/videoPreview"),
    audioPreview: () => import("@/components/Table/TablePreview/audioPreview"),
    imgPreview: () => import("@/components/Table/TablePreview/imgPreview"),
    txtPreview: () => import("@/components/Table/TablePreview/txtPreview"),
    officePreview: () =>
      import("@/components/Table/TablePreview/officePreview"),
    pdfPreview: () => import("@/components/Table/TablePreview/pdfPreview"),
    markdownPreview: () =>
      import("@/components/Table/TablePreview/markdownPreview"),
    TableTag: () => import("./TableOperate/TableTag"),
    TableShare: () => import("./TableOperate/TableShare"),
    TableShareSelected: () => import("./TableOperate/TableShareSelected"),
    TableShareEdit: () => import("./TableOperate/TableShareEdit"),
    TableShareInfo: () => import("./TableOperate/TableShareInfo"),
    Save: () => import("@/components/Save"),
    GroupResourcePermission: () =>
      import("@/views/Group/GroupResourcePermission"),
    FileHistory: () => import("./TableOperate/FileHistory"),
  },
  props: {
    isCreateProcessing: {
      default: false,
      type: Boolean,
    },
    isList: Boolean,
  },
  data() {
    return {
      isProcessing: false,
      status: {
        SaveStatus: false,
        TableShareStatus: false,
        TableShareSelectedStatus: false,
        TableTagStatus: false,
        TableMoveStatus: false,
        TableMoveSelectedStatus: false,
        TableRestoreStatus: false,
        TableRestoreSelectedStatus: false,
        TableCopyStatus: false,
        TableCopySelectedStatus: false,
        TableShareEditStatus: false,
        TableShareInfoStatus: false,
        videoPreviewStatus: false,
        audioPreviewStatus: false,
        txtPreviewStatus: false,
        officePreviewStatus: false,
        pdfPreviewStatus: false,
        markdownPreviewStatus: false,
        imgPreviewStatus: false,
        FileHistory: false,
      },
      isPerviewing: false, // 处于弹窗状态，不显示拖拽上传
      preview_path: "",
      dialogStatus: "view",
      rightMenustyle: {},
      showRightMenu: false,
      resources: [],
      imgs: [],
      detail: {
        number: null,
        name: null,
        password: null,
        allowedIps: null,
        expiredAt: null,
        share_sharers: {
          sharer_name: "",
        },
      },
      parentFolder: null, // 点击进入目录后，保留的父目录信息
    };
  },
  filters: {
    transcodeStatusFilter: transcodeStatusFilter,
    formatData: formatData,
    bytesToSize: bytesToSize,
    shareToFilter: function (data) {
      let res;
      switch (data.share_type) {
        case "link":
          res = "-";
          break;
        case "user":
          res = data.share_sharers
            .map(function (v) {
              return v.sharer_name;
            })
            .join(",");
          res = res ? res : "-";
          break;
        case "group":
          res = data.share_sharers
            .map(function (v) {
              return v.sharer_name;
            })
            .join(",");
          res = res ? res : "-";
          break;
        default:
          res = "-";
          break;
      }
      return res;
    },
  },
  // keep-alive 组件激活时调用
  activated() {
    window.addEventListener("scroll", this.scrollLoad);
  },
  // keep-alive 组件停用时调用。
  deactivated() {
    window.removeEventListener("scroll", this.scrollLoad);
  },
  computed: {
    right__group_resource_role_batch_grant_to_members () {
      return this.$store.getters.right__group_resource_role_batch_grant_to_members
    },
    right__file_version_back_preview () {
      return this.$store.getters.right__file_version_back_preview
    },
    right__link_delete () {
      return this.$store.getters.right__link_delete
    },
    right__link () {
      return this.$store.getters.right__link
    },
    right__share_remove () {
      return this.$store.getters.right__share_remove
    },
    right__share_delete () {
      return this.$store.getters.right__share_delete
    },
    right__share_edit () {
      return this.$store.getters.right__share_edit
    },
    right__resource_tag () {
      return this.$store.getters.right__resource_tag
    },
    right__share_create () {
      return this.$store.getters.right__share_create
    },
    right__group_resource_savetocloud () {
      return this.$store.getters.right__group_resource_savetocloud
    },
    right__startag () {
      return this.$store.getters.right__startag
    },
    right__rename () {
      return this.$store.getters.right__rename
    },
    right__operationFileOrFolder () {
      return this.$store.getters.right__operationFileOrFolder
    },
    right__edit_number () {
      return this.$store.getters.right__edit_number
    },
    user() {
      return this.$store.state.user.userInfo;
    },
    isScrollTab() {
      return (
        this.showOnStar ||
        this.showOnSharefile ||
        this.showOnShareme ||
        this.showOnGroupShare ||
        this.showOnGroupSend
      );
    },
    perPage() {
      return this.$store.state.drive.perPage;
    },
    loading() {
      return this.$store.state.drive.loading;
    },
    nothing() {
      return this.$store.state.drive.nothing;
    },
    focusState() {
      return this.$store.state.drive.focusState;
    },
    folder() {
      return this.$store.state.drive.selectedFolder;
    },
    selectedDatas() {
      return this.$store.state.drive.selectedDatas;
    },
    offset() {
      return this.$store.state.drive.listQuery.offset;
    },
    total() {
      return this.$store.state.drive.total;
    },
    header() {
      if (this.showOnSharefile) {
        return "TableHeaderShare";
      } else {
        return "TableHeaderFile";
      }
    },
    group() {
      return this.$store.state.drive.group;
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
    tab() {
      return this.$store.state.drive.tab;
    },
    datas() {
      return this.$store.state.drive.datas;
    },
    showOnFile: function () {
      return this.tab === "file" || this.tab === "persona-file";
    },
    showOnStar: function () {
      return this.tab === "star";
    },
    showOnTrash: function () {
      return this.tab === "trash";
    },
    showOnSharefile: function () {
      return this.tab === "sharefile" || this.tab === "persona-sharefile";
    },
    showOnShareme: function () {
      return this.tab === "shareme";
    },
    showOnGroupFile: function () {
      return this.tab === "group-file" || this.tab === "groupdisk-file";
    },
    showOnGroupShare: function () {
      return this.tab === "group-share" || this.tab === "groupdisk-share";
    },
    showOnGroupSend: function () {
      return this.tab === "group-send" || this.tab === "groupdisk-send";
    },
    permissions() {
      return this.$store.state.group.permissions;
    },
    // 移除分享
    hasDeleteSharePermission() {
      if (this.permissions.public_operations == "ALL") {
        return true;
      }
      return (
        this.permissions.public_operations.indexOf("deleteOtherShare") > -1
      );
    },
    // 权限-上传文件
    hasUploadFilePermission() {
      if (this.permissions.public_operations == "ALL") {
        return true;
      }
      if (this.parentFolder) {
        // console.log(this.parentFolder);
        // 进入一级文件夹内，根据资源权限判断
        let number = this.parentFolder.number;
        if (this.parentFolder.parent_number != "0") {
          number = this.parentFolder.parent_path_number.slice(1, 37);
        }
        let resource = this.permissions.resource_operations.find((item) => {
          return item.folder_id === number;
        });
        if (resource) {
          let permissions = getRolePermissions(resource.role_type);
          return permissions.indexOf("uploadFiles") > -1;
        }
        return false;
      }
      return false;
    },
    // 权限-创建群文件夹
    hasCreateFolderPermission() {
      if (this.permissions.public_operations == "ALL") {
        return true;
      }
      if (this.parentFolder) {
        // 进入一级文件夹内，根据资源权限判断
        let number = this.parentFolder.number;
        if (this.parentFolder.parent_number != "0") {
          number = this.parentFolder.parent_path_number.slice(1, 37);
        }
        let resource = this.permissions.resource_operations.find((item) => {
          return item.folder_id === number;
        });
        if (resource) {
          let permissions = getRolePermissions(resource.role_type);
          return permissions.indexOf("createFolder") > -1;
        }
        return false;
      } else {
        // 对于一级文件夹，当有[允许角色成员在根目录创建文件夹并设置共享]权限时返回true
        return (
          this.permissions.public_operations.indexOf(
            "allowCreateFolderAndSetPermission"
          ) > -1
        );
      }
    },
    // 权限-编辑/取消发布（暂未使用）
    hasManagerPublishPermission() {
      let resource = this.permissions.resource_operations.find((item) => {
        return item.role_type == 6 || item.role_type == 1;
      });
      if (resource) {
        return true;
      }
      return false;
    },
  },
  directives: {
    /**
     * 滚动加载的自定义指令
     */
    scroll: {
      bind: function (el, binding, vnode) {
        window.addEventListener("scroll", vnode.context.scrollLoad);
      },
      unbind: function (el, binding, vnode) {
        //路由转跳到其他页面时，会调用unbind，解绑滚动加载事件。
        window.removeEventListener("scroll", vnode.context.scrollLoad);
      },
    },
    clickoutside: {
      bind(el, binding, vnode) {
        function documentHandler(e) {
          // 这里判断点击的元素是否是本身，是本身，则返回
          if (el.contains(e.target)) {
            return false;
          }
          // 判断指令中是否绑定了函数
          if (binding.expression) {
            // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
            binding.value(e);
          }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener("click", documentHandler);
      },
      unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener("click", el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      },
    },
  },
  methods: {
    showMoreBtn (data) {
      return (data.type === 'file' && this.hasOnePermission(data, 'previewResource'))
        || (data.type === 'folder' && this.hasOnePermission(data, 'resourceInfo'))
        || (data.type === 'file' && (this.showOnFile || this.showOnStar || this.hasOnePermission(data, 'downloadResource')))
        || (this.right__edit_number && data.type === 'file' && (this.showOnFile || this.showOnStar || this.hasOnePermission(data, 'editFile')) && ['docx', 'xlsx', 'pptx', 'md', 'markdown', 'pdf'].includes(data.file_ext))
        || (this.right__rename && (this.showOnFile ||
                        this.showOnStar ||
                        (this.hasOnePermission(data, 'renameFile') &&
                          data.type === 'file') ||
                        (this.hasOnePermission(data, 'renameFolder') &&
                          data.type === 'folder')))
        || (this.right__operationFileOrFolder && (this.showOnFile || this.showOnStar))
        || (this.right__operationFileOrFolder && (this.showOnFile || this.showOnStar))
        || (this.right__group_resource_savetocloud && this.hasOnePermission(data, 'saveResourceToCloud'))
        || (this.right__operationFileOrFolder && this.showOnTrash)
        || (this.right__operationFileOrFolder && this.showOnTrash)
        || (this.right__operationFileOrFolder && (this.showOnFile || this.showOnStar))
        || (this.right__operationFileOrFolder && this.hasOnePermission(data, 'deleteResource'))
        || this.showOnSharefile
        || (this.right__share_edit && this.showOnSharefile)
        || (this.right__share_delete && this.showOnSharefile)
        || (this.showOnShareme || this.showOnGroupShare)
        || this.showOnGroupSend
        || (this.right__link && (this.showOnGroupSend &&
                        (this.permissions.public_operations == 'ALL' ||
                          data.link_creater_number === this.user.user_number)))
        || (this.right__share_remove && ((this.showOnGroupShare &&
                          (this.hasDeleteSharePermission ||
                            data.share_creater_number === this.user.user_number)) ||
                        this.showOnShareme))
        || (this.right__link_delete && (this.showOnGroupSend &&
                        (this.permissions.public_operations == 'ALL' ||
                          data.link_creater_number === this.user.user_number)))
        || (this.right__group_resource_role_batch_grant_to_members && (this.showOnGroupFile &&
                        data.type === 'folder' &&
                        data.parent_number === '0' &&
                        this.hasOnePermission(data, 'editResourcePermission')))
        || (this.right__file_version_back_preview && ((this.showOnFile ||
                          (this.showOnGroupFile &&
                            this.hasOnePermission(data, 'viewHistoryVersion'))) &&
                        data.type === 'file'))
    },
    // 获取文件夹的权限角色
    getRole(data) {
      if (this.permissions.public_operations == "ALL") {
        return "拥有者";
      }
      if (data.number && data.parent_number) {
        let number = data.number;
        if (data.parent_number != "0") {
          if (data.parent_path_number) {
            number = data.parent_path_number.slice(1, 37);
          } else {
            // 创建文件夹时，直接给权限
            return "拥有者";
          }
        }
        let resource = this.permissions.resource_operations.find((item) => {
          return item.folder_id === number;
        });
        if (resource) {
          let role = getRole(resource.role_type);
          return `${role}`;
        }
      }
    },
    /**
     * 权限判断说明：
     * 1.创建一级文件夹的用户为该文件夹的拥有者，有全部权限
     * 2.对于一级文件，仅群主可查看和操作（api已过滤）
     */
    hasOnePermission(data, permission) {
      if (this.tab === "groupdisk-file" && this.group) {
        if (this.permissions.resource_operations === "ALL") {
          return true;
        }
        if (data.number && data.parent_number) {
          // 如果是下列权限，则先验证是否自己的文件，是，则直接给权限
          if (
            [
              "previewResource",
              "editFile",
              "renameFile",
              "viewHistoryVersion",
            ].indexOf(permission) > -1
          ) {
            if (data.creater_user_number == this.user.user_number) {
              return true;
            }
          }
          let number = data.number;
          if (data.parent_number != "0") {
            if (data.parent_path_number) {
              number = data.parent_path_number.slice(1, 37);
            } else {
              // 创建文件夹时，直接给权限
              return true;
            }
          }
          let resource = this.permissions.resource_operations.find((item) => {
            return item.folder_id === number;
          });
          if (resource) {
            let permissions = getRolePermissions(resource.role_type);
            return permissions.indexOf(permission) > -1;
          }
          return false;
        }
        return false;
      }
      return false;
    },
    isThumb: isThumb,
    imgPathFilter(data) {
      return !this.isList &&
        data.file_type === "image" &&
        isThumb(data.file_ext)
        ? `background: center / cover no-repeat url("${data.imgPath}"), #f1f1f1;`
        : "";
    },
    toggleDropdown(event) {
      this.showRightMenu = false;
      this.$refs.dropdown.map((item) => {
        if (item === event.currentTarget.parentNode) {
          $(event.currentTarget).parent().toggleClass("open");
        } else {
          item.classList.remove("open");
        }
      });
    },
    handleClickIcon(data) {
      if (this.isProcessing || this.isCreateProcessing) {
        return false;
      }
      if (
        data.type === "file" &&
        (this.showOnFile || this.showOnStar || this.showOnGroupFile)
      ) {
        this.preview(data);
      } else if (
        data.type === "folder" &&
        !data.isCreate &&
        (this.showOnFile || this.showOnStar || this.showOnGroupFile)
      ) {
        this.getInfoByFatherId(data);
      } else if (this.showOnTrash) {
        this.handleTrash();
      } else if (
        this.showOnGroupShare ||
        this.showOnShareme ||
        this.showOnSharefile
      ) {
        this.getShareResourceList(data);
      } else if (this.showOnGroupSend) {
        this.getLinkResourceList(data);
      }
    },
    handleUploadFolder() {
      Bus.$emit("openUploaderFolder", {});
    },
    handleUploadFiles() {
      Bus.$emit("openUploaderFile", {});
    },
    createNewFolder() {
      this.$emit("createNewFolder");
    },
    showOnGroupFileAndSelf(data) {
      return (
        this.tab === "groupdisk-file" &&
        this.group &&
        (this.group.group_member_identity === "owner" ||
          data.creater_user_number === this.user.user_number)
      );
    },
    showOnGroupSendAndSelf(data) {
      return (
        this.tab === "groupdisk-send" &&
        this.group &&
        (this.group.group_member_identity === "owner" ||
          data.link_creater_number === this.user.user_number)
      );
    },
    closeRightMenu() {
      this.showRightMenu = false;
    },
    rightEvent(data, e) {
      if (data.number == 0 && data.disk_type === "backup") {
        return false;
      }
      this.detail = data;
      this.rightMenustyle = {
        left: e.clientX + 5 + "px",
        top: e.clientY + 5 + "px",
      };
      this.showRightMenu = true;
      // 关闭每行的dropdown
      this.$refs.dropdown.map((item) => {
        item.classList.remove("open");
      });
      this.$store.commit("selectOneRow", data);
    },
    // 提交转码
    fileTranstate(data, event) {
      this.detail = data;
      let e = event.target;
      $(e).css({ "pointer-events": "none" });
      setTimeout(() => {
        $(e).css({ "pointer-events": "auto" });
      }, 5000);
      if (data.is_lock) {
        this.$message({
          type: "warning",
          message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      if (data.transcode_status == "wait" || data.transcode_status == "fail") {
        this.$confirm({
          type: "confirm",
          content: "确定要提交转码吗？",
          showCancleBtn: true,
          showYesBtn: true,
          custom: [],
        })
          .then(() => {
            fileTranstate({
              file_number: data.number,
              group_number: this.groupNumber,
            })
              .then((res) => {
                if (res.status_code === 202) {
                  this.$store.commit("setTranscode", {
                    data: data,
                    transcode_title: "视频正在转码，请稍等",
                    transcode_status: "progess",
                  });
                  this.$message({
                    type: "success",
                    message: res.message,
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: err,
                });
              });
          })
          .catch(() => {});
      } else if (data.transcode_status == "progess") {
        this.fileTranstateStatus(data)
          .then((res) => {
            if (res.status_code === 200) {
              if (res.entity.trans_status == "progess") {
                this.$message({
                  type: "warning",
                  message: `该视频正在转码，已完成${
                    res.entity.trans_percentage
                  }%，预计需要${formatSeconds(res.entity.take_time)}，请稍等`,
                });
              } else if (res.entity.trans_status == "success") {
                this.$store.commit("setTranscode", {
                  data: data,
                  transcode_title: "该视频已转码完成，可以播放",
                  transcode_status: "success",
                });
                // 转码成功，直接播放
                this.getPreviewPath(data).then(() => {
                  $("#video_preview").modal("show");
                });
              } else if (res.entity.trans_status == "wait") {
                this.$message({
                  type: "warning",
                  message: `该视频正在等待转码，前面排队的数量${
                    res.entity.trans_queue_count
                  }，预计需要${formatSeconds(res.entity.take_time)}，请稍等`,
                });
              } else if (res.entity.trans_status == "fail") {
                this.$store.commit("setTranscode", {
                  data: data,
                  transcode_title: "视频转码失败，点击重试",
                  transcode_status: "fail",
                });
                this.$message({
                  type: "error",
                  message: res.entity.trans_message,
                });
              }
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      }
    },
    // 转码状态
    fileTranstateStatus(data) {
      return new Promise((resolve, reject) => {
        fileTranstateStatus({
          number: data.number,
          group_number: this.groupNumber,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleSaveSelected() {
      this.resources = this.selectedDatas;
      this.getSaveTree("save");
    },
    handleSave(data, action = null) {
      this.showRightMenu = false;
      if (data.is_lock) {
        this.$message({
          type: "warning",
          message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      this.resources = [data];
      if (action) {
        this.getSaveTree(action);
      }
    },
    getSaveTree(action) {
      let that = this;
      getFileInfo({
        number: 0,
        is_rec: true,
        category: "folder",
        disk_type: "cloud",
      })
        .then((res) => {
          let tree = [
            {
              disk_type: "cloud",
              number: "0",
              text: "我的云盘",
              nodes: listToTree(res.entity.datas),
            },
          ];
          $("#treeview-" + action).treeview({
            expandIcon: "ti ti-angle-right",
            collapseIcon: "ti ti-angle-down",
            nodeIcon: "iconfont icon-folder",
            showTags: true,
            onNodeSelected: function (event, data) {
              that.$store.commit("selectedFolder", data);
            },
            onNodeUnselected: function (event, data) {
              that.$store.commit("selectedFolder", null);
            },
            data: tree,
          });
          $("#" + action).on("hidden.bs.modal", function (e) {
            that.$store.commit("selectedFolder", null);
          });
          $("#" + action).modal("show");
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    getInfo() {
      this.$store.dispatch("getInfo").then(() => {
        if (!this.isList) {
          this.$store.dispatch("getImgPath");
        }
      });
    },
    handlePreviewData(payload) {
      // 仅选中该条数据
      this.$store.commit("selectOneRow", payload.data);
      switch (payload.action) {
        case "move":
          this.handleMoveData(payload.data, "move");
          break;
        case "copy":
          this.handleCopyData(payload.data, "copy");
          break;
        case "share":
          this.detail = payload.data;
          $("#share").modal("show");
          break;
      }
      if (payload.type === "img") {
        this.imgs = [];
      }
    },
    deletePreviewData(data) {
      this.$store.commit("deleteFileOrFolder", data);
    },
    deleteImagePreviewData(index) {
      this.imgs.splice(index, 1);
    },
    edit(data) {
      this.showRightMenu = false;
      if (data.is_lock) {
        this.$message({
          type: "warning",
          message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      this.detail = data;
      this.dialogStatus = "edit";
      if (["docx", "pptx", "xlsx"].includes(data.file_ext)) {
        this.$nextTick(() => {
          $("#office_preview").modal("show");
        });
      } else if (["md", "markdown"].includes(data.file_ext)) {
        // this.getPreviewPath(data).then(() => {
        this.$nextTick(() => {
          $("#markdown_preview").modal("show");
        });
        // });
      } else if ("pdf" === data.file_ext) {
        this.$nextTick(() => {
          $("#pdf_preview").modal("show");
        });
      }
    },
    // 修改预览状态
    changePreviewStatus(status) {
      this.isPerviewing = status;
    },
    // 修改文件版本号
    changeVersion(version) {
      this.$store.commit("changeVersion", {
        data: this.detail,
        version: version,
      });
    },
    updateCreateToEditStatus(file) {
      this.$store.commit("changeFileData", {
        data: this.detail,
        newData: {
          number: file.number,
          name: file.name,
        },
      });
      this.dialogStatus = "edit";
      // this.getInfo();
    },
    updateEditToCreateStatus(dialogStatus) {
      this.dialogStatus = dialogStatus;
    },
    preview(data, previewOffice = false) {
      // 判断是否有预览资源权限
      if (
        this.showOnGroupFile &&
        !this.hasOnePermission(data, "previewResource")
      ) {
        return false;
      }
      this.showRightMenu = false;
      this.detail = data;
      let type = getPreviewType(data.type, data.file_type, data.file_ext);
      // 支持未识别的视频类型的播放
      if (type === "unknow" && data.file_type === "video") {
        type = "mp4";
      }
      switch (type) {
        case "mp4":
          if (
            data.transcode_status == "none" ||
            data.transcode_status == "success"
          ) {
            this.getPreviewPath(data).then(() => {
              $("#video_preview").modal("show");
            });
          } else if (data.transcode_status == "wait") {
            this.$message({
              type: "warning",
              message: "视频暂未转码，请先点击转码，转码完成后即可播放",
            });
          } else if (data.transcode_status == "progess") {
            this.fileTranstateStatus(data)
              .then((res) => {
                if (res.status_code === 200) {
                  if (res.entity.trans_status == "progess") {
                    this.$message({
                      type: "warning",
                      message: `该视频正在转码，已完成${
                        res.entity.trans_percentage
                      }%，预计需要${formatSeconds(
                        res.entity.take_time
                      )}，请稍等`,
                    });
                  } else if (res.entity.trans_status == "success") {
                    this.$store.commit("setTranscode", {
                      data: data,
                      transcode_title: "该视频已转码完成，可以播放",
                      transcode_status: "success",
                    });
                    // 转码成功，直接播放
                    this.getPreviewPath(data).then(() => {
                      $("#video_preview").modal("show");
                    });
                  } else if (res.entity.trans_status == "wait") {
                    this.$message({
                      type: "warning",
                      message: `该视频正在等待转码，前面排队的数量${
                        res.entity.trans_queue_count
                      }，预计需要${formatSeconds(
                        res.entity.take_time
                      )}，请稍等`,
                    });
                  } else if (res.entity.trans_status == "fail") {
                    this.$store.commit("setTranscode", {
                      data: data,
                      transcode_title: "视频转码失败，点击重试",
                      transcode_status: "fail",
                    });
                    this.$message({
                      type: "error",
                      message: res.entity.trans_message,
                    });
                  }
                } else {
                  this.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: err,
                });
              });
          } else if (data.transcode_status == "fail") {
            this.$message({
              type: "error",
              message: "视频转码失败，无法播放",
            });
          } else if (data.transcode_status == "notran") {
            this.$message({
              type: "warning",
              message: "该文件暂不支持在线预览",
              // message: "本视频不支持转码，也不支持直接预览",
            });
          }
          break;
        case "audio":
          this.getPreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#audio_preview").modal("show");
            });
          });
          break;
        case "office":
          if (
            ["file", "star", "groupdisk-file", "persona-file"].indexOf(
              this.tab
            ) > -1 &&
            ["docx", "pptx", "xlsx"].includes(data.file_ext) &&
            !previewOffice
          ) {
            if ("groupdisk-file" == this.tab) {
              this.dialogStatus = "view";
              this.getPreviewPath(data).then(() => {
                this.$nextTick(() => {
                  $("#office_preview").modal("show");
                });
              });
            } else {
              this.dialogStatus = "edit";
              this.getEditPath(data).then(() => {
                this.$nextTick(() => {
                  $("#office_preview").modal("show");
                });
              });
            }
          } else {
            this.dialogStatus = "view";
            this.getPreviewPath(data).then(() => {
              this.$nextTick(() => {
                $("#office_preview").modal("show");
              });
            });
          }
          break;
        case "pdf":
          this.dialogStatus = "view";
          this.getPreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#pdf_preview").modal("show");
            });
          });
          break;
        case "markdown":
          this.dialogStatus = "view";
          this.getPreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#markdown_preview").modal("show");
            });
          });
          break;
        case "img":
          this.getPreviewPath(data).then(() => {
            this.imgs = this.datas
              .filter((item) => {
                return item.file_type === "image";
              })
              .map((file) => {
                if (file.number === data.number) {
                  file.show = true;
                } else {
                  file.show = false;
                }
                return file;
              });
            this.$nextTick(() => {
              $("#img_preview").modal("show");
            });
          });
          break;
        case "txt":
          this.getPreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#txt_preview").modal("show");
            });
          });
          break;
        default:
          if (previewTxts.includes(data.file_ext)) {
            this.getPreviewPath(data).then(() => {
              this.$nextTick(() => {
                $("#txt_preview").modal("show");
              });
            });
          } else {
            this.$message({
              type: "warning",
              message: "该文件暂不支持在线预览",
            });
          }
          break;
      }
    },
    getPreviewPath(data) {
      return new Promise((resolve) => {
        preview({
          number: data.number,
          group_number: this.groupNumber,
        })
          .then((res) => {
            if (res.status_code === 200) {
              if (data.is_lock) {
                this.$message({
                  type: "warning",
                  message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
                });
                return false;
              }
              resolve(res);
            } else if (res.status_code === 410) {
              this.$message({
                type: "error",
                message: res.message,
              });
              let index = this.datas.indexOf(data);
              this.$store.commit("deleteFileOrFolder", index);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      });
    },
    getEditPath(data) {
      return new Promise((resolve) => {
        edit({
          number: data.number,
          group_number: this.groupNumber,
        })
          .then((res) => {
            if (res.status_code === 200) {
              if (data.is_lock) {
                this.$message({
                  type: "warning",
                  message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
                });
                return false;
              }
              resolve(res);
            } else if (res.status_code === 410) {
              this.$message({
                type: "error",
                message: res.message,
              });
              let index = this.datas.indexOf(data);
              this.$store.commit("deleteFileOrFolder", index);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      });
    },
    scrollLoad() {
      if (
        this.showOnFile ||
        this.showOnTrash ||
        this.showOnGroupFile ||
        this.tab === "persona-sharefile"
      ) {
        return false;
      }
      // 滚动条高度（页面被卷去高度）
      let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      // 文档高度
      let bodyHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      let hh = scrollTop + window.innerHeight >= bodyHeight - 300;
      // console.log(hh + "--------" + this.loading);
      if (hh && this.offset < this.total - this.perPage) {
        if (this.loading) {
          return false;
        } else {
          this.$store.commit("setPage", this.offset + this.perPage);
          this.$store.dispatch("getInfo").then((res) => {
            if (res.entity.datas.length) {
              if (this.showOnStar && !this.isList) {
                this.$store.dispatch("getImgPath");
              }
            }
          });
        }
      }
    },
    handleTrash() {
      this.$message({
        type: "warning",
        message: "回收站中不支持打开操作",
      });
    },
    handleRename(data) {
      this.$store.commit("setFocusState", false);
      this.showRightMenu = false;
      if (data.is_lock) {
        this.$message({
          type: "warning",
          message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      this.$store.commit("handleRename", data);
      this.$nextTick(function () {
        this.$store.commit("setFocusState2", {
          status: true,
        });
      });
    },
    getIcon(type, file_type, file_ext) {
      return getIcon(type, file_type, file_ext);
    },
    selectRow(data) {
      this.$store.commit("selectRow", data);
    },
    getInfoByFatherId(data) {
      if (data.type === "folder") {
        this.parentFolder = data;
        this.$emit("getInfoByFatherId", data);
      }
    },
    // 获取分享资源列表
    getShareResourceList(data) {
      this.$emit("getShareResourceList", data);
    },
    // 获取发布资源列表
    getLinkResourceList(data) {
      this.$emit("getLinkResourceList", data);
    },
    cancleSaveNewFolder(data) {
      this.errors.remove("title");
      this.$nextTick(function () {
        this.$store.commit("setFocusState2", {
          status: false,
          data: data,
        });
      });
      if (data.isCreate) {
        this.$store.commit("deleteFileOrFolder", data);
      }
    },
    // 通过按Enter保存
    saveNewFolderByEnter(data, event) {
      if (this.isProcessing || this.isCreateProcessing) {
        return false;
      }
      this.isProcessing = true;
      let value = $(event.currentTarget).val().trim();
      this.saveNewFolder(data, value);
    },
    // 通过点击保存按钮保存
    saveNewFolderByBtn(data, event) {
      if (this.isProcessing || this.isCreateProcessing) {
        return false;
      }
      this.isProcessing = true;
      let value = $(event.currentTarget).prev().val().trim();
      this.saveNewFolder(data, value);
    },
    // 保存
    saveNewFolder(data, value) {
      let validObj = verifyFilename(value);
      if (!validObj.valid) {
        this.isProcessing = false;
        this.errors.remove("title");
        this.errors.add({
          field: "title",
          msg: validObj.msg,
        });
        return false;
      } else {
        this.errors.remove("title");
      }
      if (data.isCreate) {
        this.$emit("saveNewFolder", value);
        this.isProcessing = false;
      } else {
        this.$store
          .dispatch("rename", {
            name: value,
            number: data.number,
            type: data.type,
            group_number: this.groupNumber,
          })
          .then((res) => {
            if (res.status_code === 200) {
              this.isProcessing = false;
              this.$store.commit("RENAME", {
                data: data,
                newValue: res.entity.new_name,
                last_update_date: res.entity.last_update_date,
              });
              this.$message({
                type: "success",
                message: res.message,
              });
              this.$nextTick(function () {
                this.$store.commit("setFocusState2", {
                  status: false,
                  data: data,
                });
              });
              // this.getInfo();
            } else {
              this.isProcessing = false;
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.isProcessing = false;
            this.$message({
              type: "error",
              message: err,
            });
          });
      }
    },
    toggleStar(data) {
      this.showRightMenu = false;
      if (data.is_lock) {
        this.$message({
          type: "warning",
          message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      this.$store
        .dispatch("toggleStar", data)
        .then((res) => {
          if (res.status_code === 200) {
            if (this.tab === "star" && data.is_star) {
              this.$store.commit("deleteFileOrFolder", data);
            } else {
              this.$store.commit("toggleStar", data);
            }
          } else if (res.status_code === 410) {
            this.$message({
              type: "error",
              message: res.message,
            });
            this.$store.commit("deleteFileOrFolder", data);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    deleteFileOrFolder(data) {
      this.showRightMenu = false;
      this.$confirm({
        type: "confirm",
        content: `确定彻底删除【${formatData(data)}】吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          this.$store.commit("operationFileOrFolderData", {
            group_number: this.groupNumber,
            action: "delete",
            disk_type: data.disk_type,
            files_list: [
              {
                number: data.number,
                type: data.type,
              },
            ],
          });
          this.$store
            .dispatch("handleFileOrFolder", data)
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$store.commit("deleteFileOrFolder", data);
              } else if (res.status_code === 410) {
                this.$store.commit("deleteFileOrFolder", data);
                this.$message({
                  type: "error",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    recycleFileOrFolder(data) {
      this.showRightMenu = false;
      this.$confirm({
        type: "confirm",
        content: `确定删除【${formatData(data)}】吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          this.$store.commit("operationFileOrFolderData", {
            group_number: this.groupNumber,
            action: "recycle",
            disk_type: data.disk_type,
            files_list: [
              {
                number: data.number,
                type: data.type,
              },
            ],
          });
          this.$store
            .dispatch("handleFileOrFolder", data)
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$store.commit("deleteFileOrFolder", data);
              } else if (res.status_code === 410) {
                this.$store.commit("deleteFileOrFolder", data);
                this.$message({
                  type: "error",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    // 发布详情
    handleLinkData(data, action = null) {
      this.showRightMenu = false;
      linkInfo({
        link_number: data.link_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setShareInfo", res.entity);
            $("#" + action).modal("show");
          } else if (res.status_code === 410) {
            this.$message({
              type: "error",
              message: res.message,
            });
            this.$store.commit("deleteFileOrFolder", data);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 分享详情
    handleShareTargetData(data, action = null) {
      this.showRightMenu = false;
      shareTargetInfo({
        share_number: data.share_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setShareInfo", res.entity);
            $("#" + action).modal("show");
          } else if (res.status_code === 410) {
            this.$message({
              type: "error",
              message: res.message,
            });
            this.$store.commit("deleteFileOrFolder", data);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 分享详情/编辑分享
    handleShareData(data, action = null) {
      this.showRightMenu = false;
      shareInfo({
        share_number: data.share_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setShareInfo", res.entity);
            $("#" + action).modal("show");
          } else if (res.status_code === 410) {
            this.$message({
              type: "error",
              message: res.message,
            });
            this.$store.commit("deleteFileOrFolder", data);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 创建/编辑发布
    handleSend(action, data = null) {
      if (action === "send_edit") {
        this.showRightMenu = false;
        linkInfo({
          link_number: data.link_number,
        })
          .then((res) => {
            if (res.status_code === 200) {
              this.$store.commit("setShareInfo", res.entity);
              $("#" + action).modal("show");
            } else if (res.status_code === 410) {
              this.$message({
                type: "error",
                message: res.message,
              });
              this.$store.commit("deleteFileOrFolder", data);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      } else {
        $("#" + action).modal("show");
      }
    },
    handleData(data, action = null) {
      this.showRightMenu = false;
      if (data.is_lock) {
        this.$message({
          type: "warning",
          message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      this.detail = data;
      $("#" + action).modal("show");
    },
    handleCopyData(data, action = null) {
      this.showRightMenu = false;
      this.detail = data;
      if (action) {
        this.getCopyTree(action);
      }
    },
    getCopyTree(action) {
      let that = this;
      getFileInfo({
        group_number: this.groupNumber,
        number: 0,
        is_rec: true,
        category: "folder",
        disk_type: "cloud",
      })
        .then((res) => {
          let tree = [
            {
              disk_type: "cloud",
              number: "0",
              text: this.groupNumber ? "我的群盘" : "我的云盘",
              state: {
                selected: true,
              },
              nodes: listToTreeForCopy(res.entity.datas, [this.detail]),
            },
          ];
          that.$store.commit("selectedFolder", tree[0]);
          $("#treeview-" + action).treeview({
            expandIcon: "ti ti-angle-right",
            collapseIcon: "ti ti-angle-down",
            nodeIcon: "iconfont icon-folder",
            showTags: true,
            onNodeSelected: function (event, data) {
              that.$store.commit("selectedFolder", data);
            },
            onNodeUnselected: function (event, data) {
              that.$store.commit("selectedFolder", null);
            },
            data: tree,
          });
          $("#" + action).on("hidden.bs.modal", function (e) {
            that.$store.commit("selectedFolder", null);
          });
          $("#" + action).modal("show");
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    handleMoveData(data, action = null) {
      this.showRightMenu = false;
      this.detail = data;
      if (action) {
        this.getMoveTree(action);
      }
    },
    download(data) {
      if (data.is_lock) {
        this.$message({
          type: "warning",
          message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      this.showRightMenu = false;
      // if (data.type === "folder") {
      //   // 打开本地客户端
      //   // window.location.href = "tencent://message/?uin=443062063";
      //   let jsonStr = JSON.stringify({
      //     number: data.number,
      //     name: data.name,
      //     bytes: data.bytes,
      //     type: data.type,
      //     file_ext: data.file_ext
      //   });
      //   window.location.href = `rec://,${jsonStr}`;
      //   return false;
      // }
      download({
        files_list: [data.number],
        group_number: this.groupNumber,
      })
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[data.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
            if (res.status_code === 4104) {
              this.getInfo();
            }
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    setResourcePermission(data) {
      this.detail = data;
      $("#group_resource_permission").modal("show");
    },
    deleteLinks(data) {
      this.showRightMenu = false;
      this.$confirm({
        type: "confirm",
        content: `确定取消发布吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          this.$store
            .dispatch("deleteLinks", {
              link_list: [data.link_number],
            })
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$store.commit("deleteFileOrFolder", data);
              } else if (res.status_code === 410) {
                this.$message({
                  type: "error",
                  message: res.message,
                });
                this.$store.commit("deleteFileOrFolder", data);
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    removeShares(data) {
      this.showRightMenu = false;
      this.$confirm({
        type: "confirm",
        content: `确定删除吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          let sharer_target_number;
          switch (this.tab) {
            case "shareme":
              sharer_target_number =
                this.$store.state.user.userInfo.user_number;
              break;
            case "groupdisk-share":
              sharer_target_number = this.groupNumber;
              break;
            case "groupdisk-send":
              sharer_target_number = null;
              break;
          }
          this.$store
            .dispatch("removeShares", {
              share_number: [data.share_number],
              sharer_target_number: sharer_target_number,
            })
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$store.commit("deleteFileOrFolder", data);
              } else if (res.status_code === 410) {
                this.$message({
                  type: "error",
                  message: res.message,
                });
                this.$store.commit("deleteFileOrFolder", data);
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    deleteShareOnShareFile(data) {
      this.showRightMenu = false;
      this.$confirm({
        type: "confirm",
        content: `确定取消分享【${data.share_title}】吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          this.$store
            .dispatch("deleteShares", {
              share_list: [data.share_number],
            })
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$store.commit("deleteFileOrFolder", data);
              } else if (res.status_code === 410) {
                this.$message({
                  type: "error",
                  message: res.message,
                });
                this.$store.commit("deleteFileOrFolder", data);
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    getMoveTree(action) {
      let that = this;
      getFileInfo({
        group_number: this.groupNumber,
        number: 0,
        is_rec: true,
        category: "folder",
        disk_type: "cloud",
      })
        .then((res) => {
          let tree = [
            {
              disk_type: "cloud",
              number: "0",
              text: this.groupNumber ? "我的群盘" : "我的云盘",
              selectable:
                this.detail.parent_number === "0" &&
                this.detail.disk_type === "cloud" &&
                action != "restore"
                  ? false
                  : true,
              nodes: listToTree(
                res.entity.datas,
                action == "restore" ? [] : [this.detail]
              ),
            },
          ];
          $("#treeview-" + action).treeview({
            expandIcon: "ti ti-angle-right",
            collapseIcon: "ti ti-angle-down",
            nodeIcon: "iconfont icon-folder",
            showTags: true,
            onNodeSelected: function (event, data) {
              that.$store.commit("selectedFolder", data);
            },
            onNodeUnselected: function (event, data) {
              that.$store.commit("selectedFolder", null);
            },
            data: tree,
          });
          $("#" + action).on("hidden.bs.modal", function (e) {
            that.detail = {};
          });
          $("#" + action).modal("show");
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  mounted() {
    setTimeout(() => {
      for (let key in this.status) {
        this.status[key] = true;
      }
    }, 500);
    if (["recdrive", "groupDisk"].indexOf(this.$route.name) > -1) {
      document.getElementById("dropArea").addEventListener("dragenter", (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (this.isPerviewing) {
          return false;
        }
        if (
          "file" === this.$store.state.drive.tab ||
          ("groupdisk-file" === this.$store.state.drive.tab &&
            this.hasUploadFilePermission)
        ) {
          Bus.$emit("dragenter");
        }
      });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollLoad);
  },
};
</script>

<style scoped>
.isLocked,
.isShared {
  font-size: 12px;
  margin-left: 3px;
  opacity: 0.65;
  color: #aaa;
}
.isTransed {
  font-size: 12px;
  margin-left: 3px;
}
.drive .grids .itemlist2 {
  padding: 20px 20px 50px 20px !important;
}
.drive .grids .itemlist2 .item-name {
  width: 100%;
  height: 100%;
  padding-top: 85px;
  background-color: #f1f1f1;
}
.drive .grids .itemlist2 p {
  margin-top: 5px;
}
.fs-sm {
  font-size: 12px;
}
</style>